import React, { useState } from 'react';
import styles from './Authorization.module.scss';

const Authorization = ({ securitySchemes, paramValues, handleParamChange, activeScheme, setActiveScheme }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleSchemeChange = (e) => {
    setActiveScheme(e.target.value);
  };

  if (!securitySchemes || Object.keys(securitySchemes).length === 0) {
    return (
      <div className={styles.credentialsSection}>
        <div className={styles.credentialHeader}>
            <h5 className={styles.rightPanelSectionHeader}>AUTHORIZATION</h5>
        </div>
        <p>No authorization required for this endpoint.</p>
      </div>
    );
  }

  if (!activeScheme) {
    return null; // Or some fallback UI
  }
  const activeSchemeDetails = securitySchemes[activeScheme];

  const schemeKeys = Object.keys(securitySchemes);

  return (
    <div className={styles.credentialsSection}>
      <div key={activeScheme} className={styles.credentialItem}>
        <div className={styles.credentialHeader}>
          <h5 className={styles.rightPanelSectionHeader}>AUTHORIZATION</h5>
          {schemeKeys.length > 1 ? (
            <select
              onChange={handleSchemeChange}
              value={activeScheme}
              className={styles.authTypeDropdown}
            >
              {schemeKeys.map((key) => {
                const scheme = securitySchemes[key];
                const displayName =
                  scheme.name === "authorization" ? "OAUTH2" : scheme.name;
                return (
                  <option key={key} value={key}>
                    {displayName}
                  </option>
                );
              })}
            </select>
          ) : (
            <span
              className={`${styles.authTypeLabel} ${
                activeSchemeDetails.name === "authorization"
                  ? styles.oauthLabel
                  : ""
              }`}
            >
              {activeSchemeDetails.name === "authorization"
                ? "OAUTH2"
                : activeSchemeDetails.name}
            </span>
          )}
        </div>
        <div className={styles.credentialInputWrapper}>
          {activeSchemeDetails.name === "authorization" && (
            <span className={styles.bearerPrefix}>Bearer </span>
          )}
          <input
            type={isPasswordVisible ? "text" : "password"}
            className={`${styles.credentialInput} ${
              activeSchemeDetails.name === "authorization"
                ? styles.withBearer
                : ""
            }`}
            placeholder="••••••••"
            value={paramValues[activeSchemeDetails.name] || ""}
            onChange={(e) =>
              handleParamChange(activeSchemeDetails.name, e.target.value)
            }
          />
          <button
                className={styles.toggleVisibility}
                onClick={togglePasswordVisibility}
              >
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                >
                {isPasswordVisible ? (
                    <>
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
                    </>
                ) : (
                    <>
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </>
                )}
                </svg>
            </button>
            </div>
        </div>
    </div>
  );
};

export default Authorization;